import './suppressConsoleNoise';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './i18n';

const container = document.getElementById('root');
if (container !== null) {
    const root = createRoot(container);
    root.render(<App />);
} else {
    console.error('Failed to find the root element');
}
